(() => {
  window.sokCopy2DrawerHandler = true;
  const selector = '.sok-local-product-form, .sok-catalog-product-form';
  const rootUrl = () => window.Shopify?.routes?.root || '/';
  async function cartSnapshot(root) {
    const response = await fetch(root + 'cart.js', { credentials: 'same-origin', headers: {'Accept':'application/json'} });
    if (!response.ok || !(response.headers.get('content-type') || '').includes('json')) throw new Error('Cart state unavailable');
    return response.json();
  }
  async function renderedSections(root) {
    for (const path of [root + 'cart', location.pathname]) {
      const url = new URL(path, location.origin);
      url.searchParams.set('sections','cart-drawer,cart-icon-bubble');
      const previewThemeId = new URLSearchParams(location.search).get('preview_theme_id');
      if (previewThemeId) url.searchParams.set('preview_theme_id',previewThemeId);
      try {
        const response = await fetch(url.toString(), { credentials:'same-origin', headers: {'Accept':'application/json','X-Requested-With':'XMLHttpRequest'} });
        if (!response.ok || !(response.headers.get('content-type') || '').includes('json')) continue;
        const data = await response.json();
        if (data?.['cart-drawer'] && data?.['cart-icon-bubble']) return data;
      } catch (error) { console.warn('[SOK cart] Section refresh attempt',error); }
    }
    return null;
  }
  function openDrawerAfterRefresh() {
    let reopen = false;
    try {
      reopen = sessionStorage.getItem('sokCopy2OpenDrawerAfterRefresh') === '1';
      if (reopen) sessionStorage.removeItem('sokCopy2OpenDrawerAfterRefresh');
    } catch (_) {}
    if (!reopen) return;
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') drawer.open();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded',openDrawerAfterRefresh,{once:true});
  } else {
    openDrawerAfterRefresh();
  }
  document.addEventListener('submit',async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches(selector)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.dataset.sokSubmitting === '1') return;
    const button = form.querySelector('button[type="submit"]');
    const variantId = form.querySelector('[name="id"]')?.value;
    if (!variantId) return;
    const base = rootUrl();
    const drawer = document.querySelector('cart-drawer');
    const quantity = Math.max(1,Number(form.querySelector('[name="quantity"]')?.value || 1));
    form.querySelector('.sok-add-error')?.remove();
    form.dataset.sokSubmitting = '1';
    if (button) button.disabled = true;
    try {
      // Do not depend on bundled section rendering inside the add request:
      // storefront preview and apps may return an HTML page for that request.
      let before = null;
      try { before = await cartSnapshot(base); } catch (err) { console.warn('[SOK cart] Pre-add snapshot unavailable',err); }
      const payload = new FormData();
      payload.set('id',variantId);
      payload.set('quantity',String(quantity));
      const response = await fetch(base + 'cart/add.js', {
        method:'POST', body:payload, credentials:'same-origin',
        headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
        redirect:'follow'
      });
      const contentType = response.headers.get('content-type') || '';
      let added = false;
      let message = '';
      if (contentType.includes('json')) {
        const result = await response.json();
        if (response.ok && !result.status) added = true;
        else message = result.description || result.message || 'The item could not be added.';
      } else {
        console.warn('[SOK cart] Unexpected add response', { status:response.status, url:response.url, type:contentType, redirected:response.redirected });
        message = 'The store did not return the expected cart response.';
      }
      // Check actual cart state before displaying an error or attempting another add:
      // a non-JSON response can follow a successful add, and retrying could double quantities.
      let after = null;
      try { after = await cartSnapshot(base); } catch (err) { console.warn('[SOK cart] Post-add snapshot unavailable',err); }
      if (before && after) {
        const previousQty = before.items.filter(item => String(item.id) === String(variantId)).reduce((sum,item) => sum + item.quantity,0);
        const currentQty = after.items.filter(item => String(item.id) === String(variantId)).reduce((sum,item) => sum + item.quantity,0);
        added = currentQty >= previousQty + quantity;
        if (!added && !message) message = 'The cart was not updated. Please try again.';
      }
      if (!added) throw new Error(message || 'Could not confirm that the item was added.');
      const sections = await renderedSections(base);
      if (sections && drawer?.renderContents) {
        const parsed = { id:Number(variantId), sections };
        drawer.renderContents(parsed);
      } else {
        // Refresh the current page and automatically open the updated drawer.
        // This avoids redirecting customers to the standalone cart.
        try {sessionStorage.setItem('sokCopy2OpenDrawerAfterRefresh','1');} catch (_) {}
        window.location.reload();
      }
    } catch (error) {
      console.error('[SOK cart add]',error);
      const notice = document.createElement('span');
      notice.className = 'sok-add-error';
      notice.setAttribute('role','alert');
      notice.textContent = error.message || 'Could not add this item. Please try again.';
      form.appendChild(notice);
    } finally {
      form.dataset.sokSubmitting = '0';
      if (button) button.disabled = false;
    }
  },true);
})();